import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import ErrorScreen from './ErrorScreen';
import { datadogRum } from '@datadog/browser-rum';
import { TFunction } from 'i18next';

interface InterfaceProps {
  children: React.ReactNode;
  title?: TFunction | string;
}

const reload = () => {
  window.location.href = '/';
};

function ErrorBoundary({ children, title }: InterfaceProps): JSX.Element {
  const sendErrorToRum = (error: Error, info: { componentStack: string }) => {
    datadogRum.addError(error, {
      componentStack: info.componentStack,
    });
  };

  return (
    <ReactErrorBoundary
      FallbackComponent={() => <ErrorScreen onReload={reload} title={title} />}
      onError={sendErrorToRum}
    >
      {children}
    </ReactErrorBoundary>
  );
}

export default ErrorBoundary;
